export default __webpack_public_path__ + "static/media/inviteUser.c5c0c153.svg";